import { render, staticRenderFns } from "./modalMaterialInstrument.vue?vue&type=template&id=35f32f58&"
import script from "./modalMaterialInstrument.vue?vue&type=script&lang=js&"
export * from "./modalMaterialInstrument.vue?vue&type=script&lang=js&"
import style0 from "./modalMaterialInstrument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports